var NavDrawerConstants = function() {

    this.SLIDE_NUMBER = {
        MAIN: 0,
        CAR_TYPES_MAIN: 3,
        CAR_FS_MAIN: 4,
        RESEARCH_MAIN: 5,
        RESEARCH_TOOLS: 6,
        RESEARCH_ARTICLE: 7,
        RESEARCH_MANU_DETAILS: 8,
        CAR_FS_TYPE: 9,
        CAR_FS_MAKE: 10,
        MODEL: 11,
        YEAR: 12,
        RESEARCH_TIPS: 13
    };

    this.DRAWER_HEADERS = {
        MAKE: 'Select Make',
        MODEL: 'Select Model',
        YEAR: 'Select Year',
        CAR_TYPES_MAIN: 'Select Car Type',
        CAR_FS_MAIN: 'Cars For Sale',
        CAR_FS_TYPE: 'Select Car Type',
        CAR_FS_MAKE: 'Select Make',
        RESEARCH_MAIN: 'Research',
        RESEARCH_TOOLS: 'Pricing & Calc.',
        RESEARCH_TIPS: 'Tips & Advice',
        RESEARCH_ARTICLE: 'Articles',
        RESEARCH_MANU_DETAILS: 'Car Makes'
    };
};

module.exports = new NavDrawerConstants();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/drawer/constants.js
// module id = 67
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14